// extracted by mini-css-extract-plugin
export default {"content":"ModalContent_content__i7pTb"};